const tokenService = {
    getValidToken: async (): Promise<string | null> => {
        try {
            const token = localStorage.getItem('ryze_access_token');

            if (!token) {
                return null;
            }

            if (token.split('.').length !== 3) {
                tokenService.clearTokens();
                return null;
            }

            return token;
        } catch (err) {
            console.error('Ryze: Error accessing token storage:', err);
            return null;
        }
    },

    clearTokens: () => {
        try {
            localStorage.removeItem('ryze_access_token');
        } catch (err) {
            console.error('Ryze: Error clearing token storage:', err);
        }
    }
};

export default tokenService;
